export enum TokenType {
    FA2 = "FA2",
    FA12 = "FA12"
}

export enum PriceSource {
    Quipuswap = "Quipuswap",
    FDX = "FDX"
}
